<template>
<v-dialog v-model="display">
</v-dialog>
</template>

<script>
import _isEmpty from "lodash/isEmpty";
import HubspotReflectionPoolHandler from '@/Controllers/helper/HubspotReflectionPoolHandler.js'

export default {
    name: 'programControl',
    created: function(){
        this.init();
    },
    data: function(){
        return {
            display: false,
            controller: null,
            haveUserPrograms: false,
            model: null,
            ready: false,
            programEnableCatMode: false,
            forceEarnCreditStep: false
        }
    },
    methods: {
        init: function(){
            var self = this;
            self.controller = new this.program_controller(self);
            self.$controller.program = self.controller;
            self.$controller.program.programStatus = this.programStatus; 
            
            var promises = [];
            promises.push(self.$controller.program.fetchPrograms());
            promises.push(self.$controller.program.fetchFeaturedProgram());
            promises.push(self.$controller.program.getLibrary());
            Promise.all(promises).then((response)=>{
                // console.log('got fetched programs',response)
            })
        },
        program_controller: function(self){
            var controller = this;
            var scope = {
                programStatus: {}
            };
            this.scope = scope;
            
            this.deperecatedAuthority = function(){
                let authorizedList = process.env.NODE_ENV == 'development' ? [1,2,3] : [1, 4363, 4364, 4367]; //local
                //let authorizedList = process.env.NODE_ENV == 'development' ? [1, 4363, 4364, 4367] : [1,2,3]; //production
                return authorizedList.includes(self.$store.getters.user.id);
            }

            this.fetchPrograms = function(){
                return controller.model.fetchPrograms().then((programs)=>{
                    controller.model.dataTranlsation.program(programs);
                });
            }

            this.fetchMyPrograms = function(){
                return controller.model.fetchMyPrograms();
            }

            this.fetchStatus = function(callBack){
                return new Promise((resolve,reject)=>{
                    controller.model.fetchStatus(callBack).then(function(){
                        resolve();
                    }).catch( err => { console.log(err)})                  
                });
            }
            
            this.getProgramProgressFingerprints = function(program, role){
                return controller.model.getProgramProgressFingerprints(program,role);
            }

            this.addToUser = function(program_id, user_id, role, callBack){
                return new Promise((resolve,reject)=>{
                    let dataToHubspotFeed = {...self.$store.getters.user}
                    var addToUser = controller.model.addToUser(program_id, user_id, role);
                    addToUser.then(function(response){
                        var trigger = {
                            added: response.data.program.addToUser.result,
                            previously_added: response.data.program.addToUser.existing.length>0
                        }
                        if (trigger.added){
                            let joinedProgramDetails = self.$store.getters.programs.filter(program => program.id==program_id)
                            console.log('joinedProgramDetails',joinedProgramDetails)
                            if (joinedProgramDetails.length>0){
                                dataToHubspotFeed['program'] = joinedProgramDetails[0].reference;
                                dataToHubspotFeed['program_id'] = joinedProgramDetails[0].id;
                                console.log({dataToHubspotFeed})
                                let hubspotFeed = HubspotReflectionPoolHandler.event.addFeed(dataToHubspotFeed, 'user_joined_program', self);
                            }
                        }
                        if(trigger.added || trigger.previously_added){
                            var jwt = response.data.program.addToUser.jwt;
                            if(jwt){
                                self.$store.dispatch('jwt',jwt);
                                controller.fetchMyPrograms().then(function(){
                                    controller.fetchStatus().then(function(){
                                        if(callBack){
                                            callBack();
                                        }
                                        resolve();
                                    })
                                })                                    
                            }else{
                                controller.fetchStatus().then(function(){
                                    if(callBack){
                                        callBack();
                                    }
                                    resolve();
                                })                             
                            }
                        }else{
                            reject(response)
                        }
                        
                    });

                });
            }

            this.removeFromUser = function(program_id, user_id, role){
                return new Promise((resolve,reject)=>{
                    if(self.$store.getters.user){
                        var removeFromUser = controller.model.removeFromUser(program_id, user_id, role);

                        removeFromUser.then(function(response){
                            var trigger = {
                                a: response.data.program.removeFromUser.result
                            }

                            if(trigger.a){
                                resolve(response)
                            }else{
                                reject(response)
                            }
                        })
                    }else{
                        reject()
                    }

                });
            }

            this.startProgram = function(program_id, user_id, role, enableCatMode, forceEarnCreditStep, referrer=null){
                if(!controller.isMine(program_id , role)){
                    controller.attemptToJoinProgram(program_id, user_id, role, referrer, function(){
                        self.$router.push('/program/'+role+'/'+program_id);
                    });
                }else{
                    self.programEnableCatMode = enableCatMode;
                    self.forceEarnCreditStep = forceEarnCreditStep!==undefined ? forceEarnCreditStep :  false;;
                    if  (self.programEnableCatMode===false &&  self.forceEarnCreditStep!==false) {
                        return self.$router.push('/program/'+role+'/'+program_id+'/'+self.forceEarnCreditStep);
                    }
                    else {
                        return self.$router.push('/program/'+role+'/'+program_id);
                    }
                }
            }

            this.attemptToJoinProgram = function(program_id, user_id, role, referrer=null, callBack=null){
                if(self.$store.getters.user){
                    controller.addToUser(program_id, user_id, role, callBack);
                }else{       
                    var onClose = function(){
                        controller.addToUser(program_id, self.$store.getters.user.id, role, callBack);
                    }
                    self.$controller.view.login.open(onClose, referrer);
                }
            }          

            this.getLibrary = function(){
                return controller.model.getLibrary();
            },  

            this.programList = function(){
                return self.programList;
            }
            
            this.programMap = function(){
                return self.programMap;
            }

            this.myPrograms = function(){
                return self.my_programList;
            }

            this.livePrograms = function(){
                return self.livePrograms;
            }
            this.nonCatPrograms = function(){
                return self.nonCatPrograms;
            }
            this.catPrograms = function(){
                return self.catPrograms;
            }
            this.demoPrograms = function(){
                return self.demoPrograms;
            }
            this.deprecatedPrograms = function(){
                return self.deprecatedPrograms;
            }
            this.devPrograms = function(){
                return self.devPrograms;
            }
            this.specialtyProgram = function() {
                return self.specialtyProgram;
            }
            this.recentlyPrograms = function() {
                return self.recentlyPrograms;
            }
            this.closedPrograms = function() {
                return self.closedPrograms;
            }
            this.liveExclusivePrograms = function(){
                return self.liveExclusivePrograms
            }

            this.isMine = function(program_id, role){
                for(let i=0; i<self.my_programList.length; i++){
                    var record = self.my_programList[i];
                    if(record.program.id == program_id && record.role == role){
                        return true;
                        break;
                    }
                }
                return false;
            }
            
            this.stepStatus = function(programStatus, enableCatMode, programSteps, override, catMinRequirementsPass, isCatAssessible, programId){
                return controller.model.stepStatus(programStatus, enableCatMode, programSteps, override, catMinRequirementsPass, isCatAssessible, programId);
            }
            
            this.stepStatusV3 = function(programStatus, enableCatMode, programSteps, override, stepsScope, catMinRequirementsPass, isCatAssessible, programId){
                return controller.model.stepStatusV3(programStatus, enableCatMode, programSteps, override, stepsScope);
            }

            this.step = new function(){
                
            }
            
            this.programProgressRate = function(stepsStatus, isNativeProgramV4=false){
                return new Promise((resolve,reject)=>{
                    const programStepsLength = Object.entries(stepsStatus.state).length;
                    if (programStepsLength){
                        const programNonCompletedStepsLength = isNativeProgramV4 ? 
                            Object.values(stepsStatus.state).filter(elem => elem.debug.blocking===true && elem.debug.enabled === true)
                                .map(elem => parseInt(elem.completion_percentage)).filter( elem => elem!==100).length
                            : Object.values(stepsStatus.state).filter(elem => elem.debug.blocking===true)
                                .map(elem => parseInt(elem.completion_percentage)).filter( elem => elem!==100).length;
                        const programOptionalStepsLength = isNativeProgramV4 ? 
                            Object.values(stepsStatus.state).filter(elem => elem.debug.blocking!==true).length
                            : Object.values(stepsStatus.state).filter(elem => elem.debug.optional!==false).length; 
                        const programCompletedStepsLength = programStepsLength - programOptionalStepsLength - programNonCompletedStepsLength;
                        
                        resolve(programCompletedStepsLength/(programStepsLength-programOptionalStepsLength));
                    }
                    else {
                        resolve(0)
                    }
                });
            }

            // Program Competed when ALL BLOCKING(mandatory) and NoN-BLOCKING(optional) items aka program flow component have 100 percent completion
            this.isProgramStateCompleted = function(stepsStatus, scope, isNativeProgramV4=true){
                let completionState = false;
                switch(scope) {
                    case "mandatory-and-optional-steps":
                        completionState = _isEmpty(stepsStatus) ? false
                            : controller.isProgramMandatoryStepsCompleted(stepsStatus) && controller.isProgramOptionalStepsCompleted(stepsStatus);
                    break;
                    
                    case "optional-steps":
                        completionState = controller.isProgramOptionalStepsCompleted(stepsStatus);
                    break;
                        
                    default:
                        completionState = controller.isProgramMandatoryStepsCompleted(stepsStatus, isNativeProgramV4);
                }                
                    
                return completionState;
            }
            
            this.isProgramMandatoryStepsCompleted = function(stepsStatus, isNativeProgramV4=true){
                if (_isEmpty(stepsStatus)) {
                    return false;
                }
                else if (isNativeProgramV4) {
                    if (Object.values(stepsStatus.state).filter(elem => elem.debug.blocking===true && elem.debug.enabled === true)
                                .map(elem => parseInt(elem.completion_percentage)).filter( elem => elem!==100).length > 0
                        ){
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else if (isNativeProgramV4===false){
                    if (Object.values(stepsStatus.state).filter(elem => elem.debug.blocking===true)
                                .map(elem => parseInt(elem.completion_percentage)).filter( elem => elem!==100).length > 0
                        ){
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                
                return true;
            }
            
            this.isProgramOptionalStepsCompleted = function(stepsStatus){
                return _isEmpty(stepsStatus) ? false : 
                            Object.values(stepsStatus.state).filter(elem => elem.debug.blocking===false && elem.debug.enabled === true)
                            .map(elem => parseInt(elem.completion_percentage)).filter( elem => elem!==100).length > 0 ? false : true;
            }
           
            this.getEearnCreditsCatStepIndex = function(steps){
                let earnCreditStepIndx = steps.findIndex(elem => { return elem.items.filter(item => item.module==='earn_credits').length>0; });
                return _isEmpty(steps) ? false : earnCreditStepIndx!==-1 ? earnCreditStepIndx+1 : false;
            }
            
            this.steps = function(enableCatMode, programCatFlow, programFlow){
                let steps = [];

                let flow = enableCatMode ? programCatFlow : programFlow;

                for(let i=0; i<flow.length; i++){
                    steps.push(flow[i]);
                }

                return steps;
            },
                    
            this.getEnableCatModeState = function(){
                return self.programEnableCatMode;
            },
                    
            this.setEnableCatModeState = function(enableCatMode){
                self.programEnableCatMode = enableCatMode !== undefined ? enableCatMode : false;
            },
                    
            this.getForceEarnCreditStep = function(){
                return self.forceEarnCreditStep;
            },
            
            this.setForceEarnCreditStep = function(payload=false){
                self.forceEarnCreditStep = payload;
            }

            this.campaignConversion = function(program_id, user_id){
                controller.model.campaignConversion(program_id, user_id)
            }

            this.fetchFeaturedProgram = function() {
                return controller.model.fetchFeaturedProgram().then((fetchFeaturedProgram)=>{
                    controller.model.dataTranlsation.featuredProgram(fetchFeaturedProgram);
                });
            }

            this.setUserProgramCompletionDatetime = function(userId=null, userRole=null, programId=null) {
                return new Promise((resolve,reject)=>{
                    if (userId!==null && userRole!==null && programId!==null){
                        return controller.model.setUserProgramCompletionDatetime(userId, userRole, programId).then( function(response){
                            if(response){
                                resolve(response)
                            }else{
                                reject(response)
                            }
                        });
                    }
                    else{
                        reject();
                    }
                });               
            }
            
            /* @return user object associated to program & hashcode combined key */
            this.verifyUserProgramRegistrationCode = function(registrationHashCode=null, programObject=null){
                return controller.model.verifyUserProgramRegistrationCode(registrationHashCode, programObject)
            }
            
            this.setUserProgramRegistrationCodeUsageState = function(registrationHashCode=null, state='N'){
                return controller.model.setUserProgramRegistrationCodeUsageState(registrationHashCode, state)
            }
            
            this.model = new function(){
                var model = this;

                this.getLibrary = function(){
                    return new Promise((resolve,reject)=>{
                        var action = 'str';
                        var call = 'library';
                        self.$sendBackgroundRequest({
                            action: action,
                            call: call
                        }).then((response)=>{
                            var library = response.data[action][call];
                            
                            if(library){
                                self.$store.dispatch('library',library);
                                resolve(response);
                            }else{
                                reject(response);
                            }                                 
                        })

                    });
                }

                this.fetchPrograms = function(){
                    self.$store.dispatch('programs',false);
                    return new Promise((resolve,reject)=>{
                        self.$sendBackgroundRequest({
                            action: 'program',
                            call: 'fetchPrograms'
                        }).then(function(response){
                            var programs = response.data.program.fetchPrograms.results;
                            if(programs){
                                resolve(programs);
                            }else{
                                reject(response);
                            }                        
                        },function(){
                            console.log('NO PROGRAMS')
                        })
                    });
                }

                this.fetchMyPrograms = function(){
                    return new Promise((resolve,reject)=>{
                        var action = 'program';
                        var call = 'fetchMyPrograms';

                        self.$sendBackgroundRequest({
                            action: action,
                            call: call
                        }).then(function(response){
                            if(response.data.program){
                                self.haveUserPrograms = true;
                                var myPrograms = response.data[action][call];

                                var user = JSON.stringify(self.$store.getters.user);
                                user = JSON.parse(user);
                                user.programs = myPrograms;
                                self.$store.dispatch('user',user);
                                resolve(response);
                            }else{
                                reject(response);
                            }
                        })
                    })
                }
                
                this.getProgramProgressFingerprints = function(program,role){
                    return new Promise( (resolve,reject)=>{                     
                        let action = 'program';
                        let call = _isEmpty(program.v3) ? 'userHasProgramSubmission' : 'userHasLegacyProgramSubmission';                     
                        self.$sendBackgroundRequest({
                            action: action,
                            call: call,
                            user_id: _isEmpty(program.v3) ? self.$store.getters.user.id : self.$store.getters.user.v3.user_id,
                            program_id: _isEmpty(program.v3) ? program.id : program.v3.program_id,
                            role: role
                        }).then(function(response){
                            if (response.status == 200) {
                                resolve(response.data[action][call]);
                            } else {
                                reject(response.status);
                            }
                        },function(response){
                            reject(Error(response.status));
                        })

                    });
                }

                this.fetchStatus = function(callBack){
                    return new Promise((resolve,reject)=>{                        
                        var programs = [];
                        for(let i=0; i<self.my_programList.length; i++){
                            var record = self.my_programList[i];
                            var pid = record.program.id;
                            
                            if(self.controller.scope.programStatus[pid]){
                                self.controller.scope.programStatus[pid][record.role] = {}
                            }else{
                                self.controller.scope.programStatus[pid] = {};
                            }
    
                            programs.push({
                                program: record.program,
                                role: record.role
                            });                        
                        }
                        
    
                        var promises = [];
                        let promise = getStatus_regular_flow(self.$store.getters.user.id);
                        promises.push(promise);

                        //For V3 Programs
                        for(let i=0; i<programs.length; i++){
                            var record = programs[i];
                            var program = record.program;
                            var role = record.role;
    
                            if(program && program.v3){
                                let promise = getStatus_v3_regular_flow(self.$store.getters.user.v3.user_id , program.v3.program_id, program.id, role);
                                promises.push(promise);
                            }
                        }
    
                        self.$store.dispatch('busy',true)
                        Promise.all(promises).then(function(){

    
                            var cat_promises = [];
                            for(let i=0; i<programs.length; i++){
                                var record = programs[i];
                                var program = record.program;
                                var role = record.role; 
    
                                if(program && program.v3 && program.v3.cat){
                                    let cat_promise = getStatus_v3_cat_flow(self.$store.getters.user.v3.user_id , program.v3.cat.program_id, program.id, role);
                                    cat_promises.push(cat_promise);
                                }
                            }    
                            self.customCLog('PROMISED: regular V3')
                            Promise.all(cat_promises).then(function(response){
                                self.customCLog('PROMISED: CAT V3')
                                self.$store.dispatch('programStatus',scope.programStatus)
                            }).then(function(){
                                if(callBack){
                                    self.customCLog('PROMISED: CALLBACK')
                                    callBack();
                                }
                                self.$store.dispatch('busy',false)
                                resolve();
                            })


                            
                            
                        }).catch( err => { reject()})
    
                        function getStatus_v3_regular_flow(v3_user_id, v3_pid, v4_pid, role){
                            return new Promise((resolve,reject)=>{
                                var action = 'program';
                                var call = 'fetchStatus_v3';
    
                                self.$sendBackgroundRequest({
                                    action: action,
                                    call: call,
                                    user_id: v3_user_id,
                                    program_id: v3_pid,
                                    role: role
                                }).then(function(response){
                                    if(response.data[action][call].submissions){
                                        var program = self.programMap[v4_pid];
    
                                        var submissions = {};
                                        let submissions_v3_item_id = {};
    
                                        var data = response.data[action][call].submissions;
                                        let data_v3_itemId = Object.entries(response.data[action][call].submissions_v3_item_id);
                                        var stepNumber = 0;
                                        for(let i in data){
                                            if( program.v3 && ( !program.v3.dropSteps || !self.in_array(i,program.v3.dropSteps) ) ){
                                                stepNumber++;
                                                submissions[stepNumber] = data[i];
                                                if (data_v3_itemId[stepNumber-1] !== undefined){
                                                    submissions_v3_item_id[data_v3_itemId[stepNumber-1][0]]= data_v3_itemId[stepNumber-1][1];
                                                }
                                            }else if(!program.v3){
                                                submissions[i] = data[i];
                                            }
                                        }
                                        self.controller.scope.programStatus[v4_pid][role] = {
                                            submissions: submissions,
                                            submissions_v3_item_id: submissions_v3_item_id
                                        };
                                        resolve(response);
                                    }else{
                                        reject(response);
                                    }
                                },function(){
                                    reject();
                                }).catch( err => { reject()})
                            })
                        }
    
                        function getStatus_v3_cat_flow(v3_user_id, v3_pid, v4_pid, role){
                            return new Promise((resolve,reject)=>{
                                var action = 'program';
                                var call = 'fetchStatus_v3';
    
                                self.$sendBackgroundRequest({
                                    action: action,
                                    call: call,
                                    user_id: v3_user_id,
                                    program_id: v3_pid,
                                    role: role
                                }).then(function(response){
                                    if(response.data[action][call].submissions){
                                        var program = self.programMap[v4_pid];
    
                                        var submissions = {};
    
                                        var data = response.data[action][call].submissions;
                                        for(let i in data){
                                            submissions[i] = data[i];
                                        }
                                                                                
                                        self.controller.scope.programStatus[v4_pid][role].cat_submissions = submissions;
                                        resolve(response)
                                    }else{
                                        reject(response);
                                    }
                                },function(){
                                    reject();
                                })
                            })
                        }

                        function getStatus_regular_flow(user_id, v4_pid, role){
                            return new Promise((resolve,reject)=>{
                                var action = 'program';
                                var call = 'fetchStatus';
    
                                self.$sendBackgroundRequest({
                                    action: action,
                                    call: call,
                                    user_id: user_id,
                                    program_id: v4_pid,
                                    role: role
                                }).then(function(response){
                                    var reply = response.data[action][call];
                                    if(reply){
                                        var program = self.programMap[v4_pid];
                                        self.controller.scope.programStatus = reply['status'];
                                        resolve(response);
                                    }else{
                                        reject(response);
                                    }
                                },function(){
                                    reject();
                                })
                            })
                        }

                    });

                }

                this.addToUser = function(program_id, user_id, role){
                    return new Promise((resolve,reject)=>{
                        var action='program';
                        var call='addToUser';
                        
                        model.campaignConversion(program_id, user_id);

                        self.$sendRequest({
                            action: action,
                            call: call,
                            user_id: user_id,
                            program_id: program_id,
                            role: role
                        }).then(function(response){
                            if(response.data[action][call].result){
                                var programs = response.data[action][call].programs;
                                if (!_isEmpty(self.$store.getters.user)){
                                    var user = JSON.stringify(self.$store.getters.user);
                                    user = JSON.parse(user);                                
                                    user.programs = programs;
                                    self.$store.dispatch('user',user);                                    
                                }
                            }
                            resolve(response)
                        }).catch( err => { reject(); console.log(err)});

                    });
                }

                this.removeFromUser = function(program_id, user_id, role){
                    return new Promise((resolve,reject)=>{
                        var action='program';
                        var call='removeFromUser';

                        self.$sendRequest({
                            action: action,
                            call: call,
                            user_id: user_id,
                            program_id: program_id,
                            role: role
                        }).then(function(response){
                            if(response.data[action][call].result){
                                var programs = response.data[action][call].programs;
                                var user = JSON.stringify(self.$store.getters.user);
                                user = JSON.parse(user);
                                user.programs = programs;
                                self.$store.dispatch('user',user);

                                resolve(response)
                            }else{
                                reject(response)
                            }
                        });
                    });
                }
                
                this.dataTranlsation = new function(){

                    this.program = function(programs){
                        for(let i=0; i<programs.length; i++){
                            let program = programs[i];

                            program.dataTranlsation = {
                                showAccreditation: program.accreditation_body!=null,
                                showAccreditation_date: program.accreditation !=null,
                                showCat: program.cat_flow != null
                            };
                        }
                        self.$store.dispatch('programs',programs);
                    }

                    this.featuredProgram = function(featuredProgramId) {
                        self.$store.dispatch('updateFeaturedProgram', featuredProgramId)
                    }
                }
                
                /*
                * @param {Object/Observer} programStatus :: collection of submission for items/entities as defined in program flow
                */
                this.stepStatus = function(programStatus, enableCatMode, programSteps, override, catMinRequirementsPass, isCatAssessible, programId){
                    catMinRequirementsPass = catMinRequirementsPass !== undefined ? catMinRequirementsPass : false;
                    isCatAssessible = isCatAssessible !== undefined ? isCatAssessible : false;
                    try {
                        if (programStatus !== undefined){
                            let submissions = programStatus[enableCatMode ? 'cat_submissions':'submissions'];
                            var steps = {};
                            var state = {};
                            let toMinCompletionByItemId = {};
                            for(let i=0; i<programSteps.length; i++){
                                var position = i+1;                                
                                if (programSteps[i].items.length==1){
                                    let step = programSteps[i].items[0];
                                    steps[position] = step;

                                    var optional = step.minCompletion == 0;
                                    var limiter = step.maxCompletion > 0;
                                    var min_completion = override.min_completion || (optional===true ? true : (submissions[step.item_id] >= step.minCompletion));
                                    var max_completion = override.max_completion===true ? false : (limiter===true ? (submissions[step.item_id] >= step.maxCompletion) : false);
                                    var previousState = position>1 ? state[position-1] : null;
                                    var to_min_completion = optional === false ? (step.minCompletion - submissions[step.item_id]) >=0 ? (step.minCompletion - submissions[step.item_id]): 0 : 0;
                                    var completion_percentage = optional===true ? null : (submissions[step.item_id] / step.minCompletion)*100; //Math.round( (submissions[position] / step.minCompletion) )*100;
                                    completion_percentage = completion_percentage > 100 ? 100 : completion_percentage;

                                    state[position] = {
                                        position: position,
                                        min_completion: min_completion,
                                        max_completion: max_completion,
                                        target_completion: step.targetCompletion,
                                        to_min_completion: to_min_completion,
                                        completion_percentage: completion_percentage,
                                        blocking: step.blocking===true ? min_completion===false : false,
                                        accessible: step.locked===true ? false : previousState ? previousState.blocking===false : position==1 || (max_completion===false && min_completion===true),
                                        locked: step.locked,
                                        submissions: submissions[step.item_id],
                                        debug: {
                                            previousState: previousState,
                                            blocking: step.blocking,
                                            locked: step.locked,
                                            optional: optional,
                                            limiter: limiter,
                                            enabled: step.enabled                                            
                                        }
                                    };
                                    state[position].accessible = override.cat_locks || (enableCatMode && (!catMinRequirementsPass || !isCatAssessible) ? false : state[position].accessible);
                                    toMinCompletionByItemId[step.item_id] = to_min_completion;
                                }
                                else if (programSteps[i].items.length>1){
                                    let previousSetState = position>1 ? state[position-1] : null;
                                    let step = programSteps[i];
                                    let itemsState = {};
                                    itemsState.items = {};
                                    for(let ii=0; ii<step.items.length; ii++){
                                        let pos = ii+1;
                                        let itemStep = step.items[ii];

                                        var optional = itemStep.minCompletion == 0;                                       
                                        var limiter = itemStep.maxCompletion > 0;
                                        var min_completion = override.min_completion || (optional===true ? true : (submissions[itemStep.item_id] >= itemStep.minCompletion));
                                        var max_completion = override.max_completion===true ? false : (limiter===true ? (submissions[itemStep.item_id] >= itemStep.maxCompletion) : false);
                                        let previousItemState = pos>1 ? itemsState.items[pos-1] : null;
                                        var to_min_completion = optional === false ? (itemStep.minCompletion - submissions[itemStep.item_id]) >=0 ? (itemStep.minCompletion - submissions[itemStep.item_id]): 0 : 0;
                                        var completion_percentage = optional===true ? null : (submissions[itemStep.item_id] / itemStep.minCompletion)*100; //Math.round( (submissions[position] / step.minCompletion) )*100;
                                        completion_percentage = completion_percentage > 100 ? 100 : completion_percentage;

                                        itemsState.items[pos] = {
                                            position: position+'_'+pos,
                                            min_completion: min_completion,
                                            max_completion: max_completion,
                                            target_completion: itemStep.targetCompletion,
                                            to_min_completion: to_min_completion,
                                            completion_percentage: completion_percentage,
                                            blocking: itemStep.blocking===true ? min_completion===false : false,
                                            accessible: itemStep.locked===true ? false : previousItemState ? previousItemState.blocking===false : pos==1 || (max_completion===false && min_completion===true),
                                            locked: itemStep.locked,
                                            debug: {
                                                previousItemState: previousItemState,
                                                blocking: itemStep.blocking,
                                                locked: itemStep.locked,
                                                optional: optional,
                                                limiter: limiter,
                                                enabled: itemStep.enabled
                                            }
                                        };
                                        toMinCompletionByItemId[itemStep.item_id] = to_min_completion;
                                    }
                                    
                                    for (const element in itemsState.items) {
                                        let itemElement = itemsState.items[element];
                                        itemsState.min_completion = itemsState.min_completion === undefined ? itemElement.min_completion : itemsState.min_completion && itemElement.min_completion;
                                        itemsState.max_completion = itemsState.max_completion === undefined ? itemElement.max_completion : itemsState.max_completion && itemElement.max_completion;
                                        itemsState.target_completion = itemsState.target_completion === undefined ? itemElement.target_completion : itemElement.target_completion;
                                        itemsState.to_min_completion = itemsState.to_min_completion === undefined ? itemElement.to_min_completion : itemsState.to_min_completion + itemElement.to_min_completion;
                                        itemsState.completion_percentage = itemsState.completion_percentage === undefined ? itemElement.completion_percentage : itemsState.completion_percentage + itemElement.completion_percentage;
                                        itemsState.blocking = itemsState.blocking === undefined ? itemElement.blocking : itemsState.blocking || itemElement.blocking;                                        
                                        itemsState.locked = itemsState.locked === undefined ? itemElement.locked : itemsState.locked && itemElement.locked;
                                        itemsState.debug = itemElement.debug;
                                    } 
                                    itemsState.accessible = itemsState.locked===true ? false : previousSetState ? previousSetState.blocking===false : position==1 || (itemsState.max_completion===false && itemsState.min_completion===true);
                                    itemsState.completion_percentage = (itemsState.completion_percentage/programSteps[i].items.length);
                                    state[position] = itemsState;
                                }
                            }

                            // For program having OPTIONAL STEP accesibilty reassessed base on unlocking_item in program flow and toMinCompletionByItemId results
                            // after all program step been processed, asseccability re-accessed again based on unlocking_item condition if presented in program flow
                            for(let i=0; i<programSteps.length; i++){
                                let items = programSteps[i].items;
                                let position = i+1;
                                for(let j=0; j<items.length; j++){
                                    let item = items[j];
                                    if (item.unlocking_item===undefined || item.unlocking_item===null || item.unlocking_item === 0){
                                        continue;
                                    }
                                    else {
                                        if (item.unlocking_rule===undefined || (item.unlocking_rule!==undefined && _isEmpty(item.unlocking_rule))){
                                            state[position].accessible = override.min_completion ? true
                                                : (item.enabled === false || item.locked) ? false
                                                : toMinCompletionByItemId[item.unlocking_item]!== undefined ? toMinCompletionByItemId[item.unlocking_item]==0 
                                                : state[position].accessible;
                                        }
                                        else {
                                            state[position].accessible = override.max_completion ? true : submissions[item.unlocking_item] >= item.unlocking_rule;
                                        }
                                    }
                                }
                            }

                            return {
                                submissions: submissions,
                                state: state
                            }

                        }else{
                            return null;
                        }
                    }
                    catch(err){
                        // do nothing - eventually dispatch with populate $store.programStatus value
                    }
                    
                    return null;
                }
                
                this.stepStatusV3 = function(programStatus, enableCatMode, programSteps, override, stepsScope){
                    try {
                        if (programStatus !== undefined){
                            let submissions = programStatus[enableCatMode ? 'cat_submissions':'submissions_v3_item_id'];
                            var steps = {};
                            var state = {};
                            for(let i=0; i<programSteps.length; i++){
                                var position = i+1;
                                var step = programSteps[i].items[0];
                                steps[position] = step;
                                let v3ItemIdentifier = step.v3_id + '_' + step.v3_module;
                                
                                var optional = step.minCompletion == 0;
                                var limiter = step.maxCompletion > 0;
                                var min_completion = override.min_completion || (optional===true ? true : (submissions[v3ItemIdentifier] >= step.minCompletion));
                                var max_completion = override.max_completion===true ? false : (limiter===true ? (submissions[v3ItemIdentifier] >= step.maxCompletion) : false);
                                var previousState = position>1 ? state[position-1] : null;
                                var to_min_completion = optional === false ? (step.minCompletion - submissions[v3ItemIdentifier]) >=0 ? (step.minCompletion - submissions[v3ItemIdentifier]): 0 : 0;
                                var completion_percentage = optional===true ? null : (submissions[v3ItemIdentifier] / step.minCompletion)*100; //Math.round( (submissions[position] / step.minCompletion) )*100;
                                completion_percentage = completion_percentage > 100 ? 100 : completion_percentage;
                                
                                state[position] = {
                                    position: position,
                                    min_completion: min_completion,
                                    max_completion: max_completion,
                                    target_completion: step.targetCompletion,
                                    to_min_completion: to_min_completion,
                                    completion_percentage: completion_percentage,
                                    blocking: step.blocking===true ? min_completion===false : false,
                                    accessible: step.locked===true ? false : previousState ? previousState.blocking===false : position==1 || (max_completion===false && min_completion===true),
                                    debug: {
                                        previousState: previousState,
                                        blocking: step.blocking,
                                        locked: step.locked,
                                        optional: optional,
                                        limiter: limiter,
                                    }
                                };
                            }

                            return {
                                submissions: submissions,
                                state: state
                            }

                        }else{
                            return null;
                        }
                    }
                    catch(err){
                        // do nothing - eventually dispatch with populate $store.programStatus value
                    }
                    
                    return null;
                }
                
                this.campaignConversion = function(program_id, user_id){
                    return new Promise((resolve, reject)=>{
                        if(window.dataLayer && self.$route.query.utm_source){
                            window.dataLayer.push({'event':'join_program'});
                            let action = 'program';
                            let call = 'utm_tracking';
                            self.$sendRequest({
                                action: action,
                                call: call,
                                user_id: user_id,
                                program_id: program_id,
                                utm: self.$route.query
                            }).then((response)=>{
                                if(response.data[action][call]){
                                    resolve(response)
                                }else{
                                    reject(response);
                                }
                            })
                        }else{
                            resolve();
                        }                        
                    })
                }

                this.fetchFeaturedProgram = function(){
                    return new Promise((resolve,reject)=>{
                        self.$sendBackgroundRequest({
                            action: 'program',
                            call: 'fetchFeaturedProgram'
                        }).then(function(response){
                            var featuredProgram = response.data.program.fetchFeaturedProgram.results;
                            if(featuredProgram && parseInt(featuredProgram.setting_value) > 0){
                                resolve(parseInt(featuredProgram.setting_value));
                            }else{
                                reject(response);
                            }                        
                        },function(){
                            self.customCLog('NO FEATURED PROGRAM');
                        })
                    });
                }
                
                this.setUserProgramCompletionDatetime = function(userId, userRole, programId){
                    return new Promise((resolve, reject)=>{
                        self.$sendBackgroundRequest({
                            action: 'program',
                            call: 'setUserProgramCompletionDatetime',
                            user_id: userId,
                            role: userRole,                               
                            program_id: programId                        
                        }).then(function(response){                          
                            if (response!==undefined && response.data.program.setUserProgramCompletionDatetime.result){                            
                                self.customCLog('USER PROGRAM COMPLETION DATE UPDATED');                                
                                resolve(true);
                            }else{
                                reject(false);
                            }                        
                        });                      
                    });
                }
                
                this.verifyUserProgramRegistrationCode = async function(registrationHashCode=null, programObject=null){
                    try {
                        let response = await self.$sendRequest({
                            action: 'program',
                            call: 'verifyUserProgramRegistrationCode',
                            registration_hash_code: registrationHashCode,
                            program_id: programObject.id
                        })
                        
                        return new Promise((resolve)=>{
                            resolve({
                                email: response.data.program.verifyUserProgramRegistrationCode.results.length ? response.data.program.verifyUserProgramRegistrationCode.results[0].email : null,
                            })
                        })
                        
                    }
                    catch(error){
                        return new Promise((resolve)=>{
                            resolve({
                                email: null,
                                message: 'ERROR sendRequest at PROGRAM::verifyUserProgramRegistrationCode'
                            })
                        })
                    }                    
                }
                
                this.setUserProgramRegistrationCodeUsageState = function(registrationHashCode=null, state='N') {
                    return new Promise((resolve, reject)=>{
                        self.$sendBackgroundRequest({
                            action: 'program',
                            call: 'setUserProgramRegistrationCodeUsageState',
                            registration_hash_code: registrationHashCode,
                            used: state
                        }).then(function(response){                          
                            if (response!==undefined && response.data.program.setUserProgramRegistrationCodeUsageState.result){                            
                                self.customCLog('USER PROGRAM VERIFICATION HASHCODE STATE UPDATED');                                
                                resolve(true);
                            }else{
                                reject(false);
                            }                        
                        });                      
                    })                    
                }
            }
        } 



    },
    computed:{
        user: function(){
            return this.$store.getters.user;
        },
        programMap: function(){
            var map = {};
            for(let i in this.$store.getters.programs){
                var program = this.$store.getters.programs[i];
                map[program.id] = program;
            }

            return map;
        },
        programList: function(){
            return this.$store.getters.programs ? this.$store.getters.programs : [];
        },
        v3_programList: function(){
            var programs = [];
            for(var i in this.programList){
                var program = this.programList[i];
                if(program.v3){
                    programs.push(program);
                }
            }

            return programs;
        },
        my_programList: function(){
            var list = [];
            if(this.user && this.user.programs){
                for(let i=0; i<this.user.programs.length; i++){
                    var record = this.user.programs[i];
                    var reference = this.programMap[record.program_id];
                    if(reference){
                        var program = this.unlink(reference);
                        list.push({
                            program: program,
                            role: record.role
                        });
                    }
                }
            }
            return list;
        },
        livePrograms: function(){
            return this.programList
                .filter(program => program.state==='live' && program.access==='public')
                .map(program => {return {program: program, role: 'user'}})
        },
        liveExclusivePrograms: function(){
            return this.programList
                .filter(program => program.state==='live' && program.access==='exclusive')
                .map(program => {return {program: program, role: 'user'}})
        },
        nonCatPrograms: function(){
            return this.livePrograms
                .filter(elem => elem.program.cat_flow===null)
                .map(elem => {return {program: elem.program, role: elem.role}})
        },
        catPrograms: function(){
            return this.livePrograms
                .filter(elem => elem.program.cat_flow!=null)
                .map(elem => {return {program: elem.program, role: elem.role}})
        },
        demoPrograms: function(){
            return this.programList
                .filter(program => program.state==='demo')
                .map(program => {return {program: program, role: this.$store.getters.user.type}})            
        },
        deprecatedPrograms: function(){
            return this.programList
                .filter(program => program.state==='deprecated')
                .map(program => {return {program: program, role: this.$store.getters.user.type}})
        },
        devPrograms: function(){
            return this.programList
                .filter(program => program.state==='dev')
                .map(program => {return {program: program, role: this.$store.getters.user.type}})            
        },  
        specialtyProgram: function() {
            var self = this;
            let specialty = this.user.specialty;
            if(specialty) {
                let specialty_split = specialty.split("_");
                let specialty_concat = specialty_split.join(' ');
                let list = this.livePrograms.filter(function(program) {
                    let program_specialty = program.program.specialty;
                    let program_specialty_map = program_specialty.map(
                        function(specialty) {
                            return specialty['en'].toLowerCase();
                        }
                    )
                    return program_specialty_map.includes(specialty_concat);
                });
                let result = list.filter(function(program) {
                    let program_id = program.program.id;
                    return !self.my_programList.some(function(myProgram) {
                        return myProgram.program.id === program_id;
                    })
                })
                return result;
            } else {
                return [];
            }
        },
        recentlyPrograms: function() {
            let list = [];
            if (this.livePrograms.length >= 15) {
                let clonePrograms = [...this.livePrograms];
                clonePrograms.sort(function(a, b) {
                return a.program.timestamp < b.program.timestamp ? 1 : -1
                });
                return clonePrograms;
            }
            return list;
        },
        closedPrograms: function(){
            return this.programList
                .filter(program => program.state==='closed')
                .map(program => {return {program: program, role: this.$store.getters.user.type}})
        }
    },
    watch:{
        user: function(){

            if(this.user && (this.user.groups && typeof this.user.groups=='object') && this.haveUserPrograms===false){
                var self = this;
                
                var fetchMyPrograms = self.controller.fetchMyPrograms().then(function(response){
                    self.controller.fetchStatus(function(){
                        if(self.$store.getters.entryURL){
                            self.$router.push(self.$store.getters.entryURL);
                        }
                    });
                });
                
                var promises = [
                    fetchMyPrograms
                ];

                Promise.all(promises);
            }

            if(!this.user){
                this.haveUserPrograms = false;
                this.init();
            }
        }
    }
}
</script>

<style>

</style>